<template>
  <div>
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CRow>
      <CCol sm="12">
        <CTableWrapper
          :items="getShuffledRollsModulesData()"
          hover
          striped
          bordered
          small
          fixed
          caption="Froms List"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CTableWrapper from "./Manage_feedback_modules.vue";
import axios from "axios";
export default {
  name: "Manage_feedback_module",
  components: { CTableWrapper },
  data() {
    return {
      roleOptions: [],
      modulesArr: [],
      roleArr: [],
	  isLoading: false
    };
  },
  mounted() {
    this.isLoading = true;
  },
  methods: {
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },
    getShuffledRollsModulesData() {
      var rollsmodulesData = [];

      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      /* role list */
      var self = this;
      var requestInfo = {
        Token: token,
        Session_User_Id: Session_User_Id,
      };
      //console.log(requestInfo);

      var data = JSON.stringify(requestInfo);
      var config = {
        method: "post",
        url: apiURL + "ManageModule/GetModuleList",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(config)
        .then((result) => {
          if (result.data.status_code == 200) {
            var obj = result.data.response;
            //console.log(obj);
            self.modulesArr = obj;
            var self1 = self;
            var data = JSON.stringify(requestInfo);
            var config = {
              method: "get",
              url: feedbackApiURL + "getAllFeedBacks",
              headers: {
                "Content-Type": "application/json",
              },
              data: data,
            };
            axios(config)
              .then((result) => {
                setTimeout(() => {
                   this.isLoading = false;
                }, 3000)
                if (result.data.status_code == 200) {
                  var obj = result.data.feedBacks;
                  var totrow = obj.length;
                  var moduleArr = self1.modulesArr;
                  for (var i = 0; i < totrow; i++) {
                    var moduleName = "";
                    var modulefind = moduleArr.find(function (jsonitem, f) {
                      if (jsonitem.Module_Id == obj[i].module_id) {
                        moduleName = jsonitem.ModuleName;
                      }
                    });
                    var row = {
                      feedback_form_id: obj[i].feedback_form_id,
                      module_name: moduleName,
                      purpose: obj[i].purpose,
                      action: "Edit",
                    };
                    rollsmodulesData.push(row);
                  }
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.data.message,
                  });
                }
              })
              .catch((error) => {
				         this.isLoading = false;
                //var errorObject=JSON.stringify(error.response.data.errors);
                //console.log(errorObject);
                this.$swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                });
              });
          } else {
			this.isLoading = false;
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.message,
            });
          }
        })
        .catch((error) => {
			this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });

      return rollsmodulesData;
    },
  },
};
</script>
